const Checkmark = () => {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
      <path
        d="M22.857 56 0 32.95l6.46-6.513 16.397 16.528L57.531 8 64 14.522 22.857 56Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Checkmark;
